import { Breadcrumbs, createTheme, GlobalStyles, Link, ThemeProvider, Typography } from "@mui/material"
import React, { ReactNode } from "react"
import AppBar from "./AppBar"
import globalStyles from "../../assets/styles/global"
import Footer from "./Footer"

export interface BreadcrumbItem {
  to?: string | null
  label: string
}

export interface LayoutProps {
  children: ReactNode
  breadcrumbs: BreadcrumbItem[]
}

const Layout = (props: LayoutProps) => {
  const theme = createTheme({
    palette: {
      mode: 'light'
    }
  })
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles styles={globalStyles as any} />
      <AppBar></AppBar>
      <div id="main-content">
        {props.breadcrumbs && props.breadcrumbs.length > 1 ? (
          <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "36px", display: {xs: "none", md: "block"} }}>
          {props.breadcrumbs.map((item: BreadcrumbItem) => (
            item.to ? (
              <Link underline="hover" color="inherit" href={item.to} key={item.label}>
                {item.label}
              </Link>
            ) : (
              <Typography color="text.primary" key={item.label}>{item.label}</Typography>
            )
          ))}
        </Breadcrumbs>
        ) : ""}
        {props.children}
        <Footer description="" title="" />
      </div>
    </ThemeProvider>
  )
}

export default Layout
